import { NgZone } from '@angular/core';
import { MonoTypeOperatorFunction, Observable, Subscriber } from 'rxjs';

export const runInZone =
  <T>(zone: NgZone): MonoTypeOperatorFunction<T> =>
  (source: Observable<T>) =>
    new Observable<T>((subscriber: Subscriber<T>) =>
      source.subscribe({
        next: (value: T) => zone.run(() => subscriber.next(value)),
        error: (err: unknown) => zone.run(() => subscriber.error(err)),
        complete: () => zone.run(() => subscriber.complete())
      })
    );
